'use-strict'

export default class {
  constructor() {
    window.addEventListener('scroll', this.checkViewport.bind(this))
    this.checkViewport()
  }

  checkViewport() {
    const items = document.querySelectorAll('.reveal')

    for (let i = 0; i < items.length; i++) {
      const item = items[i]

      if (this.isVisible(item) && !item.classList.contains('revealed')) {
        this.viewElement(item)
      }
    }
  }

  isVisible(element) {
    const distance = element.getBoundingClientRect()

    return (
      distance.top >= 0 &&
      distance.bottom - distance.height * 0.2 <=
        (window.innerHeight || document.documentElement.clientHeight)
    )
  }

  viewElement(element) {
    element.classList.add('revealed')
    element.classList.remove('reveal')
  }
}
